const checkForError = response => {
  if (response.ok) {
    return response;
  } else {
    throw new Error(`${response.status} (${response.statusText})`);
  }
};

const getJson = response => response.json();

const fetchJson = url => fetch(url).then(checkForError).then(getJson);

const formUrlEncode = o => {
  const formBody = [];
  for (var property in o) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(o[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  return formBody.join("&");
};

const fetchReport = (url, token) =>
  fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "text/csv",
      Accept: "text/csv",
    },
  }).then(checkForError);

const fetchReportPost = (url, token, body) =>
  fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "text/csv",
      Accept: "text/csv",
    },
  }).then(checkForError);

const postReportRequest = (url, token, emailAddress) =>
  fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      emailAddress,
    }),
  }).then(checkForError);

const postRequest = (url, token, request) =>
  fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  }).then(checkForError);

const saveReportResponse = (response, reportName) =>
  response.blob().then(blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = reportName;
    a.click();
  });

export {
  checkForError,
  fetchJson,
  fetchReport,
  fetchReportPost,
  formUrlEncode,
  getJson,
  postReportRequest,
  postRequest,
  saveReportResponse,
};
